export enum FormDomain {
  Unknown = 'Unknown',
  ApplicationForm = 'ApplicationForm',
  Attestation = 'Attestation',
  Release = 'Release',
  Authorization = 'Authorization',
  Login = 'Login',
  MissingItemForm = 'MissingItemForm',
}
